/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useState } from 'react';
import {
  Config,
  EditableComponent,
  MappedComponentProperties,
  ResponsiveGrid,
} from '@adobe/aem-react-editable-components';
import { Modal } from '@marriott/mi-ui-library';
import { MerchandisingModalComp } from '@marriott/mi-merch-components';
import { StyledPropertyPortalWrapper } from './PropertyPortalWrapper.styles';

export function PropertyPortalWrapper(props: Record<string, unknown>) {
  const showModel = props?.['isAuthorMode'] ? false : true;
  const [isOpen, setIsOpen] = useState(showModel);

  useEffect(() => {
      if (isOpen) {
        // document.querySelector('body')?.classList.add('mdc-dialog-scroll-lock');
        document.body.style.overflow = 'hidden';
      } else {
        // document.querySelector('body')?.classList.remove('mdc-dialog-scroll-lock');
        document.body.style.overflow = 'auto';
      }
    }, [isOpen]);

  return (
    <StyledPropertyPortalWrapper className="portal-modal-component my-4 py-2">
      <Modal
        show={isOpen}
        onClose={() => setIsOpen(false)}
        secondaryClassName="d-flex justify-content-center align-items-center"
        role="region"
      >
        <MerchandisingModalComp {...({ ...props, onCloseButtonClick: () => setIsOpen(false) } as Record<string, unknown>)} />
      </Modal>
    </StyledPropertyPortalWrapper>
  );
}

export const PropertyPortalWrapperConfig = {
  emptyLabel: 'PropertyPortalWrapper',
  isEmpty: (_props: MappedComponentProperties) => false,
  resourceType: `mi-aem-common-spa/components/content/modal`,
} as Config<MappedComponentProperties>;

export const PropertyPortalWrapperEditable = (props: Record<string, unknown>) => (
  <EditableComponent config={PropertyPortalWrapperConfig} {...props}>
    <PropertyPortalWrapper {...props} />
  </EditableComponent>
);